import { render } from "./DemographicsSectionDetails.vue?vue&type=template&id=0c6ad55b&scoped=true"
import script from "./DemographicsSectionDetails.vue?vue&type=script&lang=js"
export * from "./DemographicsSectionDetails.vue?vue&type=script&lang=js"

import "./DemographicsSectionDetails.vue?vue&type=style&index=0&id=0c6ad55b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6ad55b"],['__file',"src/components/DemographicsSectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c6ad55b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c6ad55b', __exports__)) {
    api.reload('0c6ad55b', __exports__)
  }
  
  module.hot.accept("./DemographicsSectionDetails.vue?vue&type=template&id=0c6ad55b&scoped=true", () => {
    api.rerender('0c6ad55b', render)
  })

}


export default __exports__